import { render } from "./MainApp.vue?vue&type=template&id=144c6979"
import script from "./MainApp.vue?vue&type=script&lang=js"
export * from "./MainApp.vue?vue&type=script&lang=js"

import exportComponent from "/builds/phi-indonesia/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__